import { mutatorAction } from 'satcheljs';
import getStore from '../store';
import { FailureState } from '../schema/ErrorDialogStore';
import { logUsage } from 'owa-analytics';

const setLoadFailureDialogState = mutatorAction(
    'setLoadFailureDialogState',
    (errorHidden: boolean, failureState: FailureState = 'None', autoRecovered?: boolean) => {
        const store = getStore();

        // Log only if the loader was already in an erroneous
        // state and will be hidden without user intervention.
        if (errorHidden && store.failureState !== 'None' && autoRecovered) {
            logUsage(
                'CalendarAutoRecovered',
                {
                    currentFailureState: store.failureState,
                },
                {
                    isCore: true,
                }
            );
        }

        store.loadFailureHidden = errorHidden;
        store.failureState = failureState;
    }
);

export default setLoadFailureDialogState;
